<div class="profile-page bg-secondary">
    <main class="pt-3">
        <div class="container wow fadeIn">
            <b-button variant="link" class="pl-0 mb-3" @click="goBack">
                &larr; Back to User Signon Report
            </b-button>

            <legend>Update User State</legend>

            <b-card class="mt-3" style="max-width: 480px;">
                <b-form-group label="User ID" label-size="sm">
                    <b-form-input :value="userId" disabled size="sm"></b-form-input>
                </b-form-group>

                <b-form-group v-if="fullName" label="Full Name" label-size="sm">
                    <b-form-input :value="fullName" disabled size="sm"></b-form-input>
                </b-form-group>

                <b-form-group v-if="userName" label="Username" label-size="sm">
                    <b-form-input :value="userName" disabled size="sm"></b-form-input>
                </b-form-group>

                <b-form-group label="New State" label-size="sm">
                    <b-form-select v-model="selectedState" :options="stateOptions" size="sm">
                        <template #first>
                            <b-form-select-option value="unset" disabled>-- Select a state --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>

                <b-alert :show="!!successMsg" variant="success" dismissible @dismissed="successMsg=''">
                    {{ successMsg }}
                </b-alert>
                <b-alert :show="!!errorMsg" variant="danger" dismissible @dismissed="errorMsg=''">
                    {{ errorMsg }}
                </b-alert>

                <b-button :disabled="selectedState === 'unset' || isLoading" variant="primary" pill @click="updateState">
                    Update State
                </b-button>
            </b-card>

            <div class="vld-parent">
                <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
            </div>
        </div>
    </main>
</div>
